import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-gemini-pro',
  templateUrl: './gemini-pro.component.html',
  styleUrls: ['./gemini-pro.component.scss']
})
export class GeminiProComponent {
  constructor(private dialogRef: MatDialogRef<GeminiProComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}

